import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ScriptLoaderService } from "../_services/script-loader.service";
import { AuthenticationService } from "./_services/authentication.service";
import { AlertService } from "./_services/alert.service";
import { UserService } from "./_services/user.service";
import { AlertComponent } from "./_directives/alert.component";
import { LoginCustom } from "./_helpers/login-custom";
import { Helpers } from "../helpers";

import { Observable } from 'rxjs';
import * as firebase from "firebase";

@Component({
    selector: ".m-grid.m-grid--hor.m-grid--root.m-page",
    templateUrl: './templates/login-1.component.html',
    encapsulation: ViewEncapsulation.None
})

export class AuthComponent implements OnInit {
    model: any = {};
    loading = false;
    returnUrl: string;
    facebook_login_loading: boolean;

    @ViewChild('alertSignin', { read: ViewContainerRef }) alertSignin: ViewContainerRef;
    @ViewChild('alertSigninFB', { read: ViewContainerRef }) alertSigninFB: ViewContainerRef;
    @ViewChild('alertSignup', { read: ViewContainerRef }) alertSignup: ViewContainerRef;
    @ViewChild('alertForgotPass', { read: ViewContainerRef }) alertForgotPass: ViewContainerRef;

    constructor(
        private _router: Router,
        private _script: ScriptLoaderService,
        private _userService: UserService,
        private _route: ActivatedRoute,
        private _authService: AuthenticationService,
        private _alertService: AlertService,
        private cfr: ComponentFactoryResolver) {
    }

    ngOnInit() {
        this.facebook_login_loading = false;
        const authRedirect = localStorage.getItem('authRedirect');
        if (authRedirect && authRedirect == 'True') {
            this.loading = true;
            this.facebook_login_loading = true;
        }
        this.model.remember = true;
        // get return url from route parameters or default to '/'
        this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';
        this._router.navigate([this.returnUrl]);
        const action = this._route.snapshot.queryParams['action'];
        console.debug('action:', action);

        this._script.load('body', 'assets/vendors/base/vendors.bundle.js', 'assets/demo/default/base/scripts.bundle.js')
            .then(() => {
                Helpers.setLoading(false);
                LoginCustom.init();

                // If Signup Action in URL Params
                if (action && action.toLowerCase() == 'signup') {
                    LoginCustom.displaySignUpForm();
                }
            });
    }

    // signInWithFacebook() {
    //     console.debug('Signing in with Facebook...');
    //     this.loading = true;
    //     this.facebook_login_loading = true;
    //     localStorage.setItem('authRedirect', 'True');
    //     Observable.fromPromise(this._authService.fbLogin())
    //         .subscribe(
    //             data => {
    //                 console.debug('Facebook Login Result:');
    //                 console.debug(data);
    //                 localStorage.setItem('currentUser', JSON.stringify(data.user));
    //                 const user = {
    //                     agencyId: null,
    //                     facebookProfile: data.additionalUserInfo.profile.link,
    //                     displayName: data.user.displayName,
    //                     email: data.user.email,
    //                     fullName: data.user.displayName,
    //                     image: data.user.photoURL
    //                 };
    //                 this._userService.updateFBUser(user).then( user => {
    //                     console.debug(user);
    //                     this.loading = false;
    //                     this.facebook_login_loading = false;
    //                     localStorage.removeItem('authRedirect');
    //                     this._router.navigate(['/index']);
    //                 },error =>{
    //                     console.debug(error);
    //                     this.showAlert('alertSignup');
    //                     this._alertService.error(error);
    //                     this.loading = false;
    //                     this.facebook_login_loading = false;
    //                     localStorage.setItem('authRedirect', 'False');
    //                 });
    //
    //             },
    //             error => {
    //                 var e = error;
    //                 // {code: "auth/user-not-found", message: "There is no user record corresponding to this identifier. The user may have been deleted."}
    //                 console.error(error);
    //                 this.showAlert('alertSignin');
    //                 this._alertService.error(e);
    //                 this.loading = false;
    //             });
    // }

    signinFB() {
        console.debug('Signing in with Facebook...');
        this.loading = true;
        this.facebook_login_loading = true;
        localStorage.setItem('authRedirect', 'True');
        Observable.fromPromise(this._userService.handleFBLogin())
            .subscribe(
            authResult => {
                console.debug('Auth Result:', authResult);
                console.info('Auth Provider Data:', authResult['providerData'][0]);
                console.info('Auth Provider UID', authResult['providerData'][0].uid);
                this._router.navigate([this.returnUrl]);
            }, error => {
                var e = error;
                if (error.code == 'auth/account-exists-with-different-credential') {
                    e.message = 'You already have an account linked to the email address... ' + '\n\n Please log in using your email address and password.';
                }

                this.loading = false;
                this.facebook_login_loading = false;
                localStorage.removeItem('authRedirect');
                console.debug('ERROR Logging in with Facebook: ', error);
                this.showAlert('alertSignin');
                this._alertService.error(e);
            })

    }

    signin() {
        // this._authService.login(this.model.email, this.model.password)
        this.loading = true;
        Observable.fromPromise(this._authService.login(this.model.email, this.model.password))
            .subscribe(
            data => {
                console.debug(data);
                // localStorage.setItem('currentUser', 'KFSdjbGYxdZZfMbDo1MLTcZb2Y83');
                let user = { "fullName": "Demo", "email": "demo@demo.com", "token": "fake-jwt-token" }
                localStorage.setItem('currentUser', JSON.stringify(user));
                this._router.navigate([this.returnUrl]);
            },
            error => {
                var e = error;
                // {code: "auth/user-not-found", message: "There is no user record corresponding to this identifier. The user may have been deleted."}
                console.error(error);
                if (error.code == 'auth/user-not-found') {
                    e.message = 'No such User, Please Sign up first';
                    // msg =   { code: "auth/user-not-found",
                    //           message: 'No such User, Please Sign up first '
                    //         }
                }
                this.loading = false;
                this.showAlert('alertSignin');
                this._alertService.error(e);
            })
    }

    signup() {
        console.debug('signup clicked')
        if (this.model.password === this.model.rpassword) {
            this.loading = true;
            Observable.fromPromise(this._userService.create(this.model))
                .subscribe(
                data => {
                    // this.showAlert('alertSignin');
                    // this._alertService.success('Thank you. To complete your registration please check your email.', true);
                    this.loading = false;
                    // LoginCustom.displaySignInForm();
                    this._router.navigate(['/index']);
                    this.model = {}; // Clear the form model data
                },
                error => {
                    this.loading = false;
                    this.showAlert('alertSignup');
                    this._alertService.error(error);
                });
        }
        else {
            this.showAlert('alertSignup');
            this._alertService.error('Password do not match');
            this.loading = false;
        }
        // Observable.fromPromise(this._userService.create(this.model))
        //     .subscribe(
        //     data => {
        //         this._userService.createUserInDB(this.model);
        //         this.showAlert('alertSignin');
        //         this._alertService.success('Thank you. To complete your registration please check your email.', true);
        //         this.loading = false;
        //         LoginCustom.displaySignInForm();
        //         this.model = {};
        //         this._router.navigate(['/index']);
        //     },
        //     error => {
        //         this.showAlert('alertSignup');
        //         this._alertService.error(error);
        //         this.loading = false;
        //     });
    }

    forgotPass() {
        this.loading = true;
        Observable.fromPromise(this._userService.forgotPassword(this.model.email))
            .subscribe(
            data => {
                this.showAlert('alertSignin');
                this._alertService.success('Password recovery instruction has been sent to your email.', true);
                this.loading = false;
                LoginCustom.displaySignInForm();
                this.model = {};
            },
            error => {
                this.showAlert('alertForgotPass');
                this._alertService.error(error);
                this.loading = false;
            });
    }

    showAlert(target) {
        this[target].clear();
        let factory = this.cfr.resolveComponentFactory(AlertComponent);
        let ref = this[target].createComponent(factory);
        ref.changeDetectorRef.detectChanges();
    }

}


// WEBPACK FOOTER //
// ./src/app/auth/auth.component.ts